import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import { adrModule } from './modules/adr';
import { apiDocsModule } from './modules/apiDocs';
import { authModule } from './modules/auth';
import { catalogFiltersModule } from './modules/catalogFilters';
import { fallbacksModule } from './modules/fallbacks';
import { navModule } from './modules/nav';
import { observabilityModule } from './modules/observability';
import { orgChartPlugin, orgModule } from './modules/org';
import { scmAuthModule } from './modules/scmAuth';
import { teamModule } from './modules/team';
import { techdocsModule } from './modules/techdocs';
import { testopsModule } from './modules/testops';
import { themeModule } from './modules/theme';

export default createApp({
  features: [
    catalogPlugin,
    adrModule,
    apiDocsModule,
    authModule,
    catalogFiltersModule,
    fallbacksModule,
    navModule,
    observabilityModule,
    orgModule,
    orgChartPlugin,
    scmAuthModule,
    teamModule,
    techdocsModule,
    testopsModule,
    themeModule,
  ],
});
